import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { ProfileConfirmModalComponent } from '../../../dashboard/loggedin-content/profile/profile-confirm-modal/profile-confirm-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PolicyDataService } from './../../../../_services/data-services/policy-data.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Router , RouterModule } from '@angular/router';
import {
  FormBase,
  FormBaseControlService,
  AlertService,
  GTagService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
// --- Components | Services | Models --- //
import { AddPolicyDataService } from './../../../../_services/signup-process-service/add-policy-data.service';
import { AuthenticationService } from '../../../../_services/_iam/authentication-service.service';
import { UserDataService } from '../../../../_services/data-services/user-data.service';
import { PolicyDetailsService } from '../../../../_services/my-insurance/policy-details.service';
import { StorageServiceObservablesService } from '../../../../_services/storage-service-observables/storage-service-observables.service';
import { UserService } from './../../../../_services/user.service';
import { ProfileConfirmModalService } from '../../../../_services/profile-settings/profile-confirm-modal.service';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomerProfileService } from '../../../../_services/customer-profile/customer-profile.service';
import { Constants } from '@models/constants';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ProfileConfirmModalComponent, MapfreIputWithValidationComponent, MapfreButtonComponent],
  selector: 'app-add-policy-form',
  templateUrl: './add-policy.component.html',
  providers: [FormBaseControlService],
})
export class AddPolicyComponent implements OnInit {
  /* Information
     AddPolicyDataService - is for updates and anything beyond this point
     UserService - create account
 */
  @Input() inputs: FormBase<any>[] = [];
  @Input() buttonLabel = 'ADD_POLICY';
  @Input() missingPolicyNumber: string;
  email: string;
  addPolicyForm: FormGroup;
  legalCheckbox = false;
  loading = false;
  loader = false;
  user: any;
  confirmModal: any;
  signupAddPolicy = false;
  route: string;
  isAcmic = false;
  constructor(
    private addPolicyDataService: AddPolicyDataService,
    private authService: AuthenticationService,
    private ipt: FormBaseControlService,
    public router: Router,
    private userDataService: UserDataService,
    private userService: UserService,
    private storageService: StorageServiceObservablesService,
    private policyDetailsService: PolicyDetailsService,
    private alertService: AlertService,
    private policyDataService: PolicyDataService,
    private profileConfirmModalService: ProfileConfirmModalService,
    private errorRedirectionService: ErrorRedirectionService,
    private gTagService: GTagService,
    private translate: TranslateService,
    private customerProfileService: CustomerProfileService,
    private policyService: PolicyDetailsService,
    private acmicService: AcmicService
  ) {
    this.email = this.storageService.getUserFromStorage() || '';
  }
  onServiceError(error) {
    this.loader = false;
    this.errorRedirectionService.errorRedirectHandler(error);
  }
  addPolicyToEmail(email, policyNumber) {
    this.policyService.addPolicyToEmail(email, policyNumber).subscribe(
      () => {
        setTimeout(() => {
          this.policyDetailsService
            .getPolicyDetailsByEmail(this.email)
            .subscribe(
              () => {
                this.loader = false;
                this.alertService.success(
                  'Policy added to your account.',
                  true
                );
                this.router.navigate([Constants.MY_INSURANCE]);
                if (policyNumber.length === 10) {
                  this.customerProfileService.setModalTitle('ADDPOLICY');
                }
              },
              (error) => {
                this.onServiceError(error);
              }
            );
        }, 500);
      },
      (err) => {
        this.onServiceError(err);
      }
    );
  }
  addPolicy(): void {
    const userAndPolicy = this.addPolicyToObject();
    const policynumber = userAndPolicy.policyDetail.policynumber.policyNumber;
    const zipCode = this.addPolicyForm.value.makePayment_zip;
    if (this.legalCheckbox) {
      this.loader = true;
      if (policynumber.startsWith('800803') && policynumber.length === 13) {
        if (this.router.url === Constants.MY_INSURANCE_LINK_POLICY) {
          this.policyDataService.setPolicyNumber(
            this.addPolicyForm.value.addPolicy
          );
          this.router.navigate([
            Constants.MY_INSURANCE,
            'business-policy-not-supported',
          ]);
        } else {
          this.router.navigate(['signup', 'bop']);
        }
        this.loader = false;
      } else {
        this.addPolicyDataService.updateAddPolicy(userAndPolicy);

        if (
          this.router.url === Constants.MY_INSURANCE_LINK_POLICY ||
          this.router.url === '/my-insurance/add-policy'
        ) {
          if (policynumber.length === 7) {
            userAndPolicy.policyDetail.policynumber.policyNumber =
              policynumber.slice(0, -1);
            this.addPolicyDataService.updateAddPolicy(userAndPolicy);
          }

          this.authService.verifyPolicyAndAdd(userAndPolicy, zipCode).subscribe(
            (resp) => {
              this.gTagService.triggerFormLink('addPolicyForm', 'true', '');
              if (resp) {
                if (resp === this.email) {
                  this.addPolicyToEmail(this.email, policynumber);
                } else {
                  this.router.navigate([Constants.MY_INSURANCE, 'email-not-match'], {
                    queryParams: { id: policynumber, emailId: resp },
                  });
                }
              } else {
                this.router.navigate([Constants.MY_INSURANCE, 'no-email-gw'], {
                  queryParams: { id: policynumber },
                });
              }
            },
            (err) => {
              this.loader = false;
              this.policyDataService.setPolicyNumber(
                this.addPolicyForm.value.addPolicy
              );
              this.policyDataService.setZipCode(
                this.addPolicyForm.value.makePayment_zip
              );
              this.gTagService.triggerFormLink(
                'addPolicyForm',
                'false',
                this.translate.instant('ADD_POLICY_ERROR')
              );
              const er = JSON.parse(err.error);
              if (err.status === 404) {
                // 404 - if the policy belongs to another account
                // Set policy number using user observable in policy details key
                this.user.policyDetail = this.addPolicyForm.value.addPolicy;
                this.user.b2cEmail = er.Message;
                this.userService.updateUser(this.user);
              } else if (
                err.status === 500 &&
                er.Message === 'INSURED_DETAILS_MISMATCH_ZIPCODE_PASS'
              ) {
                this.router.navigate([Constants.MY_INSURANCE, 'error-not-found']);
                return;
              }
              this.addPolicyDataService.addPolicyErrorHandler(
                err,
                policynumber
              );
            }
          );
        } else {
          this.authService.verifyPolicy(userAndPolicy).subscribe(
            (response: any) => {
              this.loader = false;
              this.gTagService.triggerFormLink('addPolicyForm', 'true', '');
              const publicId = response.insured.filter((insurer) => {
                if (userAndPolicy.userDetails.lastName === '') {
                  return (
                    insurer['Insured Name'].toLowerCase() ===
                    userAndPolicy.userDetails.firstName.toLowerCase()
                  );
                } else {
                  return (
                    insurer.firstName.toLowerCase() ===
                      userAndPolicy.userDetails.firstName.toLowerCase() &&
                    insurer.lastName.toLowerCase() ===
                      userAndPolicy.userDetails.lastName.toLowerCase()
                  );
                }
              });
              userAndPolicy.userDetails['publicId'] =
                publicId.length > 0 ? publicId[0].publicId : null;
              this.userService.updateUser(userAndPolicy);
              this.router.navigate(['signup', 'validate-email-ca']);
            },
            (err) => {
              this.loader = false;
              this.gTagService.triggerFormLink(
                'addPolicyForm',
                'false',
                this.translate.instant('VERIFY_POLICY_ERROR')
              );
              if (this.router.url === Constants.MY_INSURANCE_LINK_POLICY) {
                this.policyDataService.setPolicyNumber(
                  this.addPolicyForm.value.addPolicy
                );
              }
              if (err.status === 404) {
                // 404 - if the policy belongs to another account
                // Set policy number using user observable in policy details key
                this.user.policyDetail = this.addPolicyForm.value.addPolicy;
                this.user.b2cEmail = err.error.Message;
                this.userService.updateUser(this.user);
              }
              /* for testing only*/
              if (err.status === 504) {
              this.router.navigate(['signup', 'validate-email-ca']);
              }
              if (err.status !== 504) {
              this.addPolicyDataService.addPolicyErrorHandler(
                err,
                policynumber
              );
            }
            }
          );
        }
      }
    }
  }

  onCheckDirty() {
    this.profileConfirmModalService.onCheckDirty(this.addPolicyForm);
    this.profileConfirmModalService.$checkDirty.subscribe((value) => {
      this.confirmModal = value;
    });

    if (this.addPolicyForm.value.addPolicy) {
      this.profileConfirmModalService.updateCheckDitry(true);
    } else if (!this.confirmModal) {
      this.router.navigate([Constants.MY_INSURANCE]);
    }
  }

  addPolicyToObject() {
    const policyNumber =
      this.addPolicyForm.value.addPolicy &&
      this.addPolicyForm.value.addPolicy != ''
        ? this.addPolicyForm.value.addPolicy.trim()
        : this.addPolicyForm.value.addPolicy;
    const policyDetail = {
        policynumber: { policyNumber },
      },
      userAndPolicy = {
        userDetails: { ...this.user.userDetails },
        policyDetail: { ...policyDetail },
      };
    return userAndPolicy;
  }

  getLegalCheckBoxValue(e): void {
    this.legalCheckbox = e.target.checked;
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    const policy = this.policyDataService.getPolicyNumber();
    const zipCode = this.policyDataService.getZipCode();
    this.route = this.router.url;
    this.addPolicyForm = this.ipt.toFormGroup(this.inputs);
    if(this.missingPolicyNumber) {
      this.addPolicyForm.controls.addPolicy.setValue(this.missingPolicyNumber);
    }
    if (this.policyDataService.getPolicyNumber()) {
      this.addPolicyForm.patchValue({
        addPolicy: policy,
      });
    }
    if (zipCode) {
      this.addPolicyForm.patchValue({
        makePayment_zip: zipCode,
      });
    }
    if (this.router.url === '/signup/add-policy') {
      this.signupAddPolicy = true;
    }
    if (
      this.router.url === Constants.MY_INSURANCE_LINK_POLICY ||
      this.router.url === '/my-insurance/add-policy'
    ) {
      // Logged in
      this.userDataService.$userData.subscribe((user) => {
        this.user = user;
      });
    } else {
      // Create Account
      this.userService.$user.subscribe((user) => {
        this.user = user;
      });
    }
  }
}
